import React from 'react'
import { InView } from 'react-intersection-observer'
import { blockInviewHandler } from '../../../../../utils/inview'
import { SVGIcon } from '../../../../../utils/svgicon'
import { slugify } from '../../../../../utils/utils'
import { ExpandBlock } from '../blocksState'

export const ExpandBlockLayout = (
  props: ExpandBlock & { isPrintMode: boolean }
) => {
  const { intro, title, items, isPrintMode } = props

  return (
    <InView
      as="section"
      triggerOnce={true}
      threshold={0}
      className="block block--wysiwyg block--expand"
      onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
    >
      <div className="block__inner container--m gutter--m">
        {(title || intro) && (
          <header className="block__content block__header">
            {title && <h2 className="block__title title--s">{title}</h2>}
            {intro && <p className="block__intro">{intro}</p>}
          </header>
        )}

        {items && items.length > 0 && (
          <ul className="block__content block__list expand">
            {items.map((item, i) => {
              const { title, text } = item
              return (
                <li
                  key={`expand-${slugify(item.title)}`}
                  className="expand__item"
                >
                  <details className="expand__details" open={isPrintMode}>
                    <summary className="expand__summary">
                      <div className="expand__summary-inner">
                        {title && (
                          <p className="expand__title text--l weight--semibold">
                            {title}
                          </p>
                        )}
                      </div>
                      {!isPrintMode && (
                        <SVGIcon
                          iconId="chevron-down"
                          size="12"
                          className="expand__chevron"
                        />
                      )}
                    </summary>

                    <div className="expand__children">
                      {text && (
                        <div
                          className="text--styled"
                          dangerouslySetInnerHTML={{ __html: text }}
                        />
                      )}
                    </div>
                  </details>
                </li>
              )
            })}
          </ul>
        )}
      </div>
    </InView>
  )
}
